import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj13 = () => {
  return (
    <Layout>
      <SEO title="Screen Pet" description="Awesome python project" />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>
      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-13">
          <div className="py-1-heading">
            <h1>Screen Pet</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/Screen%20Pet"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              My personal screen pet!
              <br />
              <br />
              Well it's a cute alive looking creature.
              <br />
              You will feel the blinking of eyes.
              <br />
              When you hover on it, it will blush and remain happy.
              <br />
              As soon as you remove hover from it, it will become sad, and
              wating for you.
              <br />
              If you double click on its face, you will notice its tounge, and
              eyes in a funny manner.
              <br />
              <br />
              cool !!!...
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Tkinter</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>HIDDEN</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>NORMAL</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Canvas</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj13
